import { connect } from 'react-redux';
import { PagePart } from './component';
import { getHeader, getFooter } from './selectors';
const mapStateToPropsHeader = (state) => {
    return {
        id: 'rpx-header',
        parts: getHeader(state),
        margins: state.page.margins,
    };
};
const mapStateToPropsFooter = (state) => {
    return {
        id: 'rpx-footer',
        parts: getFooter(state),
        margins: state.page.margins,
    };
};
export const PagePartHeader = connect(mapStateToPropsHeader)(PagePart);
export const PagePartFooter = connect(mapStateToPropsFooter)(PagePart);
//# sourceMappingURL=container.js.map